import Vue from 'vue'
import Router from 'vue-router'
import afiliacionRay from '@/components/afiliacionRay'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue);
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "afiliacionRay" ,  //
      component: afiliacionRay
    },
    {
      path: "/finalizado", //notiAfiliacion
      name: "notiAfiliacion", 
      component: () => import("../components/notiAfiliacion")
    },
  
  ]
})

/*




<router-link to="/solicitudes">Foo</router-link>
  <button @click="logOut" class="btn btn-warning">Salir</button>


  <div class="login">
    <form @submit.prevent="logIn">
      <label for="">
        <input type="text" v-model="email">
      </label>
      <label for="">
        <input type="password" v-model="password">
      </label>
      <input type="submit" value="Login">
    </form>
  </div> */



// WEBPACK FOOTER //
// ./src/router/index.js